// src/components/spatial/utils/drawGrid.js

export const buildGridLines = ({
  width,
  height,
  gridSize = 20,
  majorEvery = 5,
  offsetX = 0,
  offsetY = 0,
  zoom = 1,
}) => {
  const linesMinor = [];
  const linesMajor = [];

  if (!width || !height || !gridSize || !zoom) {
    return {
      minor: linesMinor,
      major: linesMajor,
    };
  }

  // ------------------------------------------------------------
  // Conversion écran -> monde des limites visibles du viewport
  // avec un repère monde fixe dont l’origine (0,0) ne bouge pas.
  // ------------------------------------------------------------
  const worldLeft = (0 - offsetX) / zoom;
  const worldRight = (width - offsetX) / zoom;
  const worldTop = (0 - offsetY) / zoom;
  const worldBottom = (height - offsetY) / zoom;

  // ------------------------------------------------------------
  // Première ligne de grille visible en coordonnées monde
  // On repart toujours de la vraie trame monde.
  // ------------------------------------------------------------
  const firstGridX = Math.floor(worldLeft / gridSize) * gridSize;
  const firstGridY = Math.floor(worldTop / gridSize) * gridSize;

  // Petite tolérance numérique pour tester les multiples
  const epsilon = 1e-9;

  // ------------------------------------------------------------
  // Lignes verticales
  // ------------------------------------------------------------
  for (let worldX = firstGridX; worldX <= worldRight + gridSize; worldX += gridSize) {
    const screenX = worldX * zoom + offsetX;

    const gridIndexX = Math.round(worldX / gridSize);
    const isMajor =
      Math.abs(gridIndexX % majorEvery) < epsilon;

    const target = isMajor ? linesMajor : linesMinor;

    target.push({
      x1: screenX,
      y1: 0,
      x2: screenX,
      y2: height,
    });
  }

  // ------------------------------------------------------------
  // Lignes horizontales
  // ------------------------------------------------------------
  for (let worldY = firstGridY; worldY <= worldBottom + gridSize; worldY += gridSize) {
    const screenY = worldY * zoom + offsetY;

    const gridIndexY = Math.round(worldY / gridSize);
    const isMajor =
      Math.abs(gridIndexY % majorEvery) < epsilon;

    const target = isMajor ? linesMajor : linesMinor;

    target.push({
      x1: 0,
      y1: screenY,
      x2: width,
      y2: screenY,
    });
  }

  return {
    minor: linesMinor,
    major: linesMajor,
  };
};